import { Controller } from "@hotwired/stimulus";
import { useTransition } from "stimulus-use";
import { useEmitter } from "@/emitter";

export default class extends Controller {
    connect() {
        useEmitter(this)

        useTransition(this, {
            enterActive: "transition ease-out duration-300",
            enterFrom: "transform bg-opacity-0",
            enterTo: "transform bg-opacity-50 translate-0",
            // 
            leaveActive: "transition ease-in duration-300",
            leaveFrom: "transform bg-opacity-50 translate-0",
            leaveTo: "transform bg-opacity-0",
            // 
            hiddenClass: 'hidden',
        })

        this.$on('backdrop:show', () => {
            this.enter();
        })

        this.$on('backdrop:hide', () => {
            this.leave();
        })

        this.$on('backdrop:toggle', () => {
            this.toggleTransition();
        })
    }

    disconnect() {
        this.$clear()
    }
}
